export var EAttendanceFormKey;
(function (EAttendanceFormKey) {
    EAttendanceFormKey["DATES"] = "dates";
    EAttendanceFormKey["STATUS"] = "status";
    EAttendanceFormKey["KEYWORD"] = "keyword";
    EAttendanceFormKey["LIB_IDS"] = "libIds";
})(EAttendanceFormKey || (EAttendanceFormKey = {}));
export var EAttendanceSearchBtns;
(function (EAttendanceSearchBtns) {
    EAttendanceSearchBtns["SEARCH"] = "search";
    EAttendanceSearchBtns["RESET"] = "reset";
    EAttendanceSearchBtns["EXPORT"] = "export";
})(EAttendanceSearchBtns || (EAttendanceSearchBtns = {}));
export var EBtnType;
(function (EBtnType) {
    EBtnType["PRIMARY"] = "primary";
})(EBtnType || (EBtnType = {}));
export var EFormItemType;
(function (EFormItemType) {
    EFormItemType["DATES"] = "dates";
    EFormItemType["INPUT"] = "input";
    EFormItemType["SELECT"] = "select";
    EFormItemType["LIB_PORTAIT"] = "libPortait";
})(EFormItemType || (EFormItemType = {}));
export var EStatusType;
(function (EStatusType) {
    EStatusType["NORMAL"] = "NORMAL";
    EStatusType["LATE"] = "WORK_LATE";
    EStatusType["EARLY"] = "LEAVING_EARLY";
    EStatusType["ABSENCE"] = "ABSENCE_FROM_DUTY";
    EStatusType["LATE_EARLY"] = "WORK_LATE_AND_LEAVING_EARLY";
})(EStatusType || (EStatusType = {}));
export var EColumnType;
(function (EColumnType) {
    EColumnType["PREIVEW"] = "PREIVEW";
    EColumnType["BTNS"] = "BTNS";
    EColumnType["STATUS"] = "STATUS";
})(EColumnType || (EColumnType = {}));
export var IColumnBtnKey;
(function (IColumnBtnKey) {
    IColumnBtnKey["VIEW"] = "view";
})(IColumnBtnKey || (IColumnBtnKey = {}));
